import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'tzConvert'
})
export class TzConvertPipe implements PipeTransform {

  transform(value: any, timezone: number, format: string): unknown {
    return moment.parseZone(value.toString()).utc(true).zone(timezone).format(format);
  }

}
